export default __webpack_public_path__ + "static/web-badge-42d10b30964c10437ff6fa40330b97ac.svg";